import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import LockedLeasePacket from './LockedLeasePacket';
import UnlockedLeasePacket from './UnlockedLeasePacket';
import { resetAddendums, updateAddendums } from './reducer';

function LeasePacket(props) {
  return props.isLeaseLocked ? (
    <LockedLeasePacket {...props} />
  ) : (
    <UnlockedLeasePacket {...props} />
  );
}

export default connect(
  (state) => {
    return {
      addendums: state.leasePacket.addendums,
      storedLeaseId: state.leasePacket.leaseId,
      isSelectionReady: state.leasePacket.isReady,
    };
  },
  {
    updateAddendums,
    resetAddendums,
  },
)(injectIntl(LeasePacket));
